/* let css/js knows you are navigating using keyboard,
    so remove any style set toward keyboard focus usage */
const accessibilityMouseActions = (body) => {
    $('body a').blur();
    if (!body.hasClass('using-mouse')) {
        body.addClass('using-mouse');
    }
};
(function () {
    if (navigator.userAgent.indexOf('SMART-TV') === -1) {
        const body = $('body');
        body.on('mousemove', () => {
            accessibilityMouseActions(body);
        });
        body.on('mousedown', () => {
            accessibilityMouseActions(body);
        });

        /* let css/js knows you are using keyboard tabbing instead of mouse */
        body.keydown(function () {
            if (body.hasClass('using-mouse')) {
                body.removeClass('using-mouse');
            }
        });
    }
})();
